import { render, staticRenderFns } from "./Intrest.vue?vue&type=template&id=64a76bba&"
import script from "./Intrest.vue?vue&type=script&lang=js&"
export * from "./Intrest.vue?vue&type=script&lang=js&"
import style0 from "./Intrest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports